import React, { useState, useEffect } from "react";
import "../styles/custom-contact-type.scss";
import { GuiRadio } from "../components/global-ui/gui-radio";
import { GuiButton } from "../components/global-ui/gui-button";
import { GuiTextbox } from "../components/global-ui/gui-textbox";
import { CustomContacsApi } from "../actions/custom-contacts-actions";
import { showToast } from "../components/toast";
import { CustomContactTypes } from "../utilities/constants";

const CustomContactType = ({
  userId,
  back,
  isMobile,
  getCustomContactTypes,
  data,
  onCustomContactEdit,
}) => {
  const [selectedType, setSelectedType] = useState("");
  const [customTypeName, setCustomTypeName] = useState("");

  const onChangeCustomType = (name, value) => {
    setCustomTypeName(value);
  };

  const saveCustomContact = async () => {
    const payload = {
      customTypeMethod: selectedType,
      customTypeName: customTypeName.trim(),
    };

    try {
      if (userId) {
        const response = await CustomContacsApi.saveCustomContactTypeForSpecificUser(payload, userId);
        if (response?.success) {
          showToast("success", "Custom contact added");
          getCustomContactTypes?.();
          back?.();
        }
      }
      else {
        const response = await CustomContacsApi.saveCustomType(payload);
        if (response?.success) {
          showToast("success", "Custom contact added");
          getCustomContactTypes?.();
          back?.();
        }
      }
    } catch (error) {
      console.error("Error saving custom contact type:", error);
      showToast("error", "An unexpected error occurred.");
    }
  };

  const editCustomContact = async () => {
    const payload = {
      customTypeMethod: selectedType,
      customTypeName: customTypeName.trim(),
    };

    try {
      if (userId) {
        const response = await CustomContacsApi.editCustomContactTypeForSpecificUser(
          data?.id,
          payload,
          userId
        );
        if (response?.success) {
          showToast("success", "Custom contact updated");
          onCustomContactEdit();
          getCustomContactTypes?.();
          back?.();
        }
      } else {
        const response = await CustomContacsApi.editCustomContact(
          data?.id,
          payload
        );

        if (response?.success) {
          showToast("success", "Custom contact updated");
          onCustomContactEdit();
          getCustomContactTypes?.();
          back?.();
        }
      }
    } catch (error) {
      console.error("Error updating custom contact type:", error);
      showToast("error", "An unexpected error occurred.");
    }
  };

  const onSaveClick = () => {
    if (data === null) {
      saveCustomContact();
    } else {
      editCustomContact();
    }
  };

  useEffect(() => {
    if (data) {
      setSelectedType(data?.customTypeMethod || "");
      setCustomTypeName(data?.label || "");
    }
  }, [data]);

  return (
    <div className="Modal Show">
      <div className="page-title">
        <span id="back" className="nav-button" onClick={back}>
          <i className="far fa-chevron-left"></i>
          {!isMobile && "Back"}
        </span>
      </div>
      <div className="custom-contact-body">
        <div className="contact-status">
          <span className="contact-status-header">
            Select the Contact Method Type
          </span>
          <div className="contact-status-body">
            <GuiRadio
              label="Home Phone"
              name="contactType"
              id={CustomContactTypes.HomePhone}
              value={selectedType}
              onChange={(name, val) => setSelectedType(val)}
            />

            <GuiRadio
              label="Work Phone"
              name="contactType"
              id={CustomContactTypes.WorkPhone}
              value={selectedType}
              onChange={(name, val) => setSelectedType(val)}
            />

            <GuiRadio
              label="Cell Phone"
              name="contactType"
              id={CustomContactTypes.CellPhone}
              value={selectedType}
              onChange={(name, val) => setSelectedType(val)}
            />

            <GuiRadio
              label="Email"
              name="contactType"
              id={CustomContactTypes.Email}
              value={selectedType}
              onChange={(name, val) => setSelectedType(val)}
            />

            <GuiRadio
              label="Address"
              name="contactType"
              id={CustomContactTypes.Address}
              value={selectedType}
              onChange={(name, val) => setSelectedType(val)}
            />
          </div>
        </div>
        <div className="contact-status">
          <span className="contact-status-header">Name of Custom Contact</span>
          <div className="contact-status-body">
            <div className="group-properties">
              <GuiTextbox
                className="form-row"
                name="name"
                value={customTypeName}
                onChange={onChangeCustomType}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <div className="modal-footer-hr-divider"></div>
        <div className="modal-footer-btns">
          <GuiButton
            className="btn-outline schedule"
            disabled={!selectedType.trim() || !customTypeName.trim()}
            onClick={onSaveClick}
          >
            Save
          </GuiButton>
        </div>
      </div>
    </div>
  );
};

export default CustomContactType;
